import { Component } from '@angular/core';

@Component({
  selector: 'app-modal-loading-overlay-close',
  templateUrl: './modal-loading-overlay-close.component.html',
  styleUrls: ['./modal-loading-overlay-close.component.scss']
})
export class ModalLoadingOverlayCloseComponent {

}
